import React from 'react';
import Reveal from './Reveal';
import { Heading, Link } from '@chakra-ui/react';

const CovidTrackerContent = () => {
  return (
    <Reveal>
      <Heading as="p" size="md" lineHeight={1.4} mr={6} ml={6} mt={8}>
        Description:
        <br />
        CovidTracker is a simple Web-App that utilizes third-party API to
        display information about the Covid-19 cases around the world. I made
        this App to train myself on how to use public API and utilizing the data
        I get from it. For example, I used the country code from the API to get
        each country image from another source called{' '}
        <Link href="flagcdn.com" isExternal color="orange.500">
          flagcdn.com
        </Link>
        .<br />
        <br />
        If you interested more about this project, go ahead and clone it from
        Github.
        <br />
        <Link
          href="https://github.com/reinaldousadani/CovidTracker"
          isExternal
          color="orange.500"
        >
          Link to Github repo.
        </Link>
        <br />
        <br />
        Technology Used:{' '}
        <Link href="https://reactjs.org" isExternal color="orange.500">
          ReactJS
        </Link>
        <br />
        Credits to{' '}
        <Link href="https://github.com/mathdroid" isExternal color="orange.500">
          mathdroid
        </Link>{' '}
        for creating the Covid-19 API. It's really cool.
      </Heading>
    </Reveal>
  );
};

export default CovidTrackerContent;
